<script setup lang="ts">
import HreflangTags from "../Components/HreflangTags.vue";
import Modal from "@/Modal/Modal.vue";
import LoginCard from "@/Components/Cards/LoginCard.vue";
import { usePage } from "@inertiajs/vue3";
import { nextTick, onMounted, onBeforeUnmount, ref } from "vue";
import { useToast } from "vue-toastification";
import { Head } from "@inertiajs/vue3";

const page = usePage();
const toast = useToast();
const showLoginModal = ref(false);

const openLoginModal = () => {
    showLoginModal.value = true;
};

const closeLoginModal = () => {
    showLoginModal.value = false;
};

onMounted(() => {
    if (page.props.flash.toast) {
        nextTick(() => {
            toast(page.props.flash.toast.message, {
                type: page.props.flash.toast.type,
            });
        });
    }

    window.addEventListener("open-login-modal", openLoginModal);
});

onBeforeUnmount(() => {
    window.removeEventListener("open-login-modal", openLoginModal);
});
</script>

<template>
    <Head>
        <title>Marketplace</title>
        <meta
            head-key="description"
            name="description"
            content="Découvrez Joinsteer, spécialiste du leasing, de la LOA et de la location longue durée (LLD) de voitures premium sélectionnées. Simplicité et transparence."
        />
    </Head>
    <HreflangTags />

    <main class="app-main">
        <slot></slot>
    </main>

    <Modal :show="showLoginModal" @close="closeLoginModal">
        <template #content>
            <LoginCard @logged="closeLoginModal" />
        </template>
    </Modal>
</template>

<style scoped>
.app-main {
    flex-grow: 1;
}
</style>
